
import React from 'react'
import './image.css'

const Image = () => {
  return (
   <div className="photo">
    <div className="txt1"><span>new & designed</span>  with purposed</div>
    <div className="txt2">SHOP SOFAS & SECTIONALS</div>
    <img src="https://cb.scene7.com/is/image/Crate/CB_20230713_HP_Sofas1?wid=1440&qlt=80&op_sharpen=1" alt="" />
    <div className="txt3"><span>1500+ new fall arival</span></div>
    <div className="txt4">SHOP NOW</div>
    <img src="https://cb.scene7.com/is/image/Crate/CB_20230713_HP_FallDecor1?wid=1440&qlt=80&op_sharpen=1" alt=""/>
   </div>
  )
}

export default Image